<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { comment } = defineProps<{
    comment: string;
  }>();
</script>

<template>
  <div class="order-comment" data-testid="order-comment">
    <Text font="body-regular-14">{{ comment }}</Text>
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.57754 10L5.69519 8.58484C5.96257 8.41155 6.22995 8.19013 6.49733 7.92058C6.76471 7.65102 7.01426 7.35259 7.24599 7.02527C7.47772 6.69795 7.62923 6.39952 7.70054 6.12996C7.20143 6.0722 6.77362 5.87004 6.41711 5.52347C6.07843 5.1769 5.90909 4.69555 5.90909 4.07942C5.90909 3.40554 6.11408 2.89531 6.52406 2.54874C6.93405 2.18291 7.41533 2 7.96791 2C8.68093 2.01925 9.19786 2.30806 9.51872 2.86643C9.83957 3.42479 10 4.0698 10 4.80144C10 5.59085 9.83957 6.34176 9.51872 7.05415C9.19786 7.76655 8.77005 8.38267 8.23529 8.90253C7.71836 9.40313 7.16578 9.76895 6.57754 10ZM0.882353 10L0 8.58484C0.249554 8.41155 0.508021 8.19013 0.775401 7.92058C1.06061 7.65102 1.31016 7.35259 1.52406 7.02527C1.75579 6.69795 1.91622 6.39952 2.00535 6.12996C1.50624 6.0722 1.07843 5.87004 0.721925 5.52347C0.383244 5.1769 0.213904 4.69555 0.213904 4.07942C0.213904 3.40554 0.409982 2.89531 0.802139 2.54874C1.21212 2.18291 1.70232 2 2.27273 2C2.96791 2.01925 3.47594 2.30806 3.79679 2.86643C4.11765 3.42479 4.27807 4.0698 4.27807 4.80144C4.27807 5.59085 4.10873 6.34176 3.77005 7.05415C3.4492 7.76655 3.0303 8.38267 2.51337 8.90253C2.01426 9.40313 1.47059 9.76895 0.882353 10Z"
        fill="var(--sf-base-text-primary)"
      />
    </svg>
  </div>
</template>

<style scoped>
  .order-comment {
    display: flex;
    gap: 6px;
    padding: 6px 10px;
    background-color: var(--sf-base-background-secondary);
    border-radius: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
